import { useBillingLaunchSubscriptionMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useLaunchSubscription = () => {
  const [mutation, mutationResult] = useBillingLaunchSubscriptionMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (companyId: string, licensesIds: string[]) => {
    const mutationResult = await mutation({
      variables: {
        input: { licensesIds, companyId },
      },
      refetchQueries: ['billingCompanyBillingInfo'],
    });

    return !!mutationResult.data?.launchSubscription?.ok;
  };

  const result = {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
  };

  return {
    request,
    result,
  };
};

export default useLaunchSubscription;
